var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathfooterIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.978,
    height: 64.084,
    viewBox: "0 0 63.978 64.084",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M20.6045 3.08174C19.6424 0.753777 17.1059 -0.485298 14.6818 0.178045C14.6818 0.178045 3.68607 3.18186 3.68607 3.18186C1.51192 3.78263 0 5.76014 0 8.01301C0 38.9774 25.0653 64.0843 55.9783 64.0843C58.2275 64.0843 60.2017 62.5699 60.8015 60.3921C60.8015 60.3921 63.8003 49.3781 63.8003 49.3781C64.4626 46.95 63.2255 44.4093 60.9014 43.4456C60.9014 43.4456 48.9061 38.4392 48.9061 38.4392C46.8694 37.5881 44.5078 38.1764 43.1208 39.891C43.1208 39.891 38.0728 46.0614 38.0728 46.0614C29.2762 41.8936 22.1539 34.7595 17.993 25.9483C17.993 25.9483 24.1532 20.9044 24.1532 20.9044C25.865 19.5026 26.4523 17.1496 25.6026 15.1095C25.6026 15.1095 20.6045 3.09425 20.6045 3.09425C20.6045 3.09425 20.6045 3.08174 20.6045 3.08174Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathfooterIcons);
export default __webpack_public_path__ + "static/media/PathfooterIcons.526acc3fe05a3c7953d7a2f8619ea4b4.svg";
export { ForwardRef as ReactComponent };